import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '../vue_widgets/calendar_events.vue'

export default class extends Controller {

  static values = {
    chatbotId: String,
    currentDate: String,
    splitDays: Array
  }

  connect(context) {
    if (document.documentElement.hasAttribute('data-turbo-preview')) return
    console.log('location mgmt widget controller connected.')

    const props = {
      chatbotId: this.chatbotIdValue,
      currentDate: this.currentDateValue,
      splitDays: this.splitDaysValue
    }

    this.vue = createApp(App, props)
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
